import React from 'react';
import PropTypes from 'prop-types';

import Translate from '@hydra/common/components/i18n';

import CriteriumTechnologyList from '@hydra/common/criterium/CriteriumTechnologyList';
import Criterium from '@hydra/common/criterium/Criterium';

export const AnalyticsTechnologies = ({ criterium }) => {
  const { data } = criterium;

  return (
    <Criterium criterium={criterium}>
      {data.technologies && data.technologies.length > 0
        ? <CriteriumTechnologyList technologies={data.technologies} />
        : <Translate content='analytics_ko' />}
    </Criterium>
  );
};

AnalyticsTechnologies.propTypes = {
  criterium: PropTypes.shape({
    data: PropTypes.shape({
      technologies: PropTypes.array
    })
  })
};

export default React.memo(AnalyticsTechnologies);
